import React, { useEffect, useState } from 'react';
import { useExerUser } from '@/common/hooks/ExerUser';
import { useHttpContext } from '@/common/hooks/HttpContext';
import { Location, UserProfile } from '@/common/types';
import { isAdmin, isUserProfile } from '@/common/utils';
import { PageTitle } from '@/components/common/PageTitle/PageTitle';
import { Result, resultIsError } from '@/services/HttpService';
import { OrganizationWrapper, LocationsAddLocation } from '../styles';
import { AddPractitioner } from './AddPractitioner/AddPractitioner';
import { PractitionersListContainer } from './PractitionersListContainer';
import { PractitionersProvider } from './context/PractitionersContext';

export const Practitioners = () => {
    const { user } = useExerUser();
    const { httpService } = useHttpContext();
    const [locations, setLocations] = useState<Location[]>();
    const [userProfile, setUserProfile] = useState<UserProfile | undefined>(undefined);

    useEffect(() => {
        (async () => {
            const locationsResponse = await httpService.getLocations();
            if (resultIsError(locationsResponse)) {
                return;
            }
            setLocations(locationsResponse);
            const userProfileResponse: Result<UserProfile> = await httpService.getCurrentUser();
            if (isUserProfile(userProfileResponse)) {
                setUserProfile(userProfileResponse);
            }
        })();
    }, []);

    return (
        <OrganizationWrapper>
            <PageTitle title="Providers" />
            <PractitionersProvider>
                <LocationsAddLocation>
                    {isAdmin(user) && (
                        <AddPractitioner
                            isAbsolute={true}
                            locations={locations}
                            supportsSSO={userProfile?.organization?.supportsSSO || false}
                        />
                    )}
                </LocationsAddLocation>
                <PractitionersListContainer
                    locations={locations}
                    supportsSSO={userProfile?.organization?.supportsSSO || false}
                />
            </PractitionersProvider>
        </OrganizationWrapper>
    );
};
